const mutations = {
  getOurServiceBanner: (state, ourservice_banner) => {
    state.ourservice_banner = ourservice_banner;
  },
  // postPaxelcoDashboard: (state, new_paxel_dashboard) => {
  //   state.paxel_dashboard.push(new_paxel_dashboard);
  // },
};

export default mutations;
